import React from "react";
import { Navigate } from "react-router-dom";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Register1 from "../pages/AuthenticationInner/Register";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

// Seleccionar Empresa (post-login)
import SeleccionarEmpresa from "../pages/Authentication/SeleccionarEmpresa";

// Empresas
import ConsultarEmpresas from "../pages/Empresas/ConsultarEmpresas";
import Sucursales from "../pages/Empresas/Sucursales";
import Empresa from "../pages/Empresas/Empresa";
import CrearEmpresa from "../pages/Empresas/CrearEmpresa";
import Resoluciones from "../pages/Empresas/Resoluciones";

//Comprobantes
import Comprobantes from "../pages/Comprobantes/Comprobantes";
import GenerarExcel from "../pages/Comprobantes/GenerarExcel";
import FoliosFaltantes from "../pages/Comprobantes/FoliosFaltantes/index.jsx";
import AnalisisVentas from "../pages/Comprobantes/AnalisisVentas/index.jsx";
import MediosPago from "../pages/Comprobantes/MediosPago/index.jsx";
import Terceros from "../pages/Comprobantes/Terceros/index.jsx";

//Administracion
import RegistrarUsuario from "../pages/Administracion/RegistrarUsuario"

//Seguridad
import ListarRoles from "../pages/Seguridad/ListarRoles"
import GestionMenus from "../pages/Seguridad/GestionMenus";
import ListarUsuarios from "../pages/Administracion/ListarUsuarios";

//Impuestos
import ImpuestosGlobales from "../pages/Impuestos/ImpuestosGenerales/index.jsx";


//Inventarios
import AnalisisArticulos from "../pages/Inventarios/AnalisisArticulos/index.jsx";

//Mercadeo
import PerfilCliente from "../pages/Mercadeo/PerfilCliente360/index.jsx";
import MapaConsumo from "../pages/Mercadeo/MapaConsumo";

//Envío de correos
import EnvioCorreosAnalisis from "../pages/EnvioCorreos/Analisis/index.jsx";
import EnvioCorreosErrores from "../pages/EnvioCorreos/Errores/index.jsx";
import EnvioCorreosReenvioMasivo from "../pages/EnvioCorreos/ReenvioMasivo/index.jsx";
import EnvioCorreosBandeja from "../pages/EnvioCorreos/BandejaEnvios/index.jsx";
import EnvioCorreosReportes from "../pages/EnvioCorreos/ReportesEntregabilidad/index.jsx";

//Presupuestos
import PresupuestosLista from "../pages/Presupuestos/ListaPresupuestos/index.jsx";
import PresupuestosCrear from "../pages/Presupuestos/CrearPresupuesto/index.jsx";
import PresupuestosComparativo from "../pages/Presupuestos/ComparativoVentas/index.jsx";


//Extra Pages
import PagesBlank from "../pages/Extra Pages/pages-blank";
import Pages404 from "../pages/Extra Pages/pages-404";
import Pages500 from "../pages/Extra Pages/pages-500";

// Wrapper component para Navigate
const RedirectToPortal = () => <Navigate to="/portal" />;

const userRoutes = [
	{ path: "/seleccionar-empresa", component: SeleccionarEmpresa },
	{ path: "/portal", component: Dashboard },

	// // //Empresas
	{ path: "/portal/consultar-empresas", component: ConsultarEmpresas },
	{ path: "/portal/sucursales/:id", component: Sucursales },
	{ path: "/portal/empresa/crear", component: CrearEmpresa },   // ⚠️ DEBE ir antes de /:id
	{ path: "/portal/empresa/:id", component: Empresa },
	{ path: "/portal/resoluciones/:id", component: Resoluciones },

	// // //Comprobantes
	{ path: "/portal/consultar-comprobantes", component: Comprobantes },
	{ path: "/portal/reporte-comprobantes", component: GenerarExcel },
	{ path: "/portal/reporte-faltantas", component: FoliosFaltantes },
	{ path: "/portal/analisis-ventas", component: AnalisisVentas },
	{ path: "/portal/medios-pagos", component: MediosPago },
	{ path: "/portal/terceros", component: Terceros },

	// // //Administracion
	{ path: "/portal/registro", component: RegistrarUsuario },
	{ path: "/portal/usuarios", component: ListarUsuarios },

	// // //Seguridad
	{ path: "/portal/roles", component: ListarRoles },
	{ path: "/portal/menus", component: GestionMenus },

	// // //Impuestos
	{ path: "/portal/impuestos-generales", component: ImpuestosGlobales },


	// // //Inventarios
	{ path: "/portal/analisis-articulos", component: AnalisisArticulos },

	// // //Mercadeo
	{ path: "/portal/perfil-cliente", component: PerfilCliente },
	{ path: "/portal/mapa-consumo", component: MapaConsumo },

	// // //Envío de correos
	{ path: "/portal/envio-correos/analisis", component: EnvioCorreosAnalisis },
	{ path: "/portal/envio-correos/errores", component: EnvioCorreosErrores },
	{ path: "/portal/envio-correos/reenvio-masivo", component: EnvioCorreosReenvioMasivo },
	{ path: "/portal/envio-correos/bandeja", component: EnvioCorreosBandeja },
	{ path: "/portal/envio-correos/reportes", component: EnvioCorreosReportes },

	// // //Presupuestos
	{ path: "/portal/presupuestos", component: PresupuestosLista },
	{ path: "/portal/presupuestos/nuevo", component: PresupuestosCrear },
	{ path: "/portal/presupuestos/comparativo", component: PresupuestosComparativo },


	// // //profile
	{ path: "/profile", component: UserProfile },

	{ path: "/pages-blank", component: PagesBlank },

	// this route should be at the end of all other routes
	{
		path: "/",
		exact: true,
		component: RedirectToPortal,
	},
];

const authRoutes = [
	{ path: "/logout", component: Logout },
	{ path: "/login", component: Login },
	{ path: "/forgot-password", component: ForgetPwd },
	{ path: "/register", component: Register },

	{ path: "/pages-404", component: Pages404 },
	{ path: "/pages-500", component: Pages500 },

	// Authentication Inner
	{ path: "/pages-login", component: Login1 },
	{ path: "/pages-register", component: Register1 },
	{ path: "/page-recoverpw", component: Recoverpw },
	{ path: "/auth-lock-screen", component: LockScreen },
];

export { userRoutes, authRoutes };
